import { MarketType } from '@velocity-exchange/sdk';
import {
	UIMarket,
	getUserMaxLeverageForMarket,
} from '@velocity-exchange/common';
import useMarketSettingsStore from 'src/stores/useMarketSettingsStore';
import useMarketMaxLeverage from 'src/hooks/useMarketMaxLeverages';
import useCurrentUserAccount from './useCurrentUserAccount';

/**
 * Hook that calculates the display leverage for a market position.
 * Handles gathering all necessary data from stores and other hooks.
 */
export default function useGetDisplayLeverageForMarket(
	marketIndex: number | undefined
): number {
	const symbol = UIMarket.createPerpMarket(marketIndex ?? 0).uiSymbols
		.marketSymbol;

	const savedMaxLev = useMarketSettingsStore((s) =>
		s.getMaxLeverageForMarket(symbol)
	);

	const { maxLeverage } = useMarketMaxLeverage(MarketType.PERP, marketIndex);

	const user = useCurrentUserAccount()?.client;

	if (!user) return savedMaxLev ?? maxLeverage;

	return getUserMaxLeverageForMarket(
		user,
		marketIndex ?? 0,
		maxLeverage,
		savedMaxLev
	);
}
